import React, { useState } from 'react';
import { Code2, Menu, Sparkles, X } from 'lucide-react';
import profileData from '../data/profileData.json';

const Header = ({ activeSection, onSectionClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { name: 'Home', id: 'home' },
    { name: 'About', id: 'about' },
    { name: 'Skills', id: 'skills' },
    { name: 'Projects', id: 'projects' },
    { name: 'Experience', id: 'experience' },
    { name: 'Contact', id: 'contact' }
  ];

  const handleNavClick = (sectionId) => {
    onSectionClick(sectionId);
    setIsMenuOpen(false);
  };

  const isActive = (sectionId) => activeSection === sectionId;

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-slate-200/80 bg-white/90 shadow-[0_10px_30px_rgba(15,23,42,0.06)] backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <a href="#home" onClick={(e) => { e.preventDefault(); handleNavClick('home'); }} className="group flex items-center gap-3">
            <div className="relative flex h-11 w-11 items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-br from-[#1d4ed8] via-[#2563eb] to-[#7c3aed] shadow-lg shadow-blue-200 transition-all duration-300 group-hover:scale-105 group-hover:rotate-3">
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(255,255,255,0.45),_transparent_45%)]" />
              <Code2 size={20} className="relative z-10 text-white" />
              <Sparkles size={12} className="absolute right-1.5 top-1.5 text-blue-100" />
            </div>

            <div className="flex flex-col leading-tight">
              <span className="text-lg font-extrabold tracking-tight text-[#1e3a5f]">
                Ravi <span className="text-[#2563eb]">Kushwah</span>
              </span>
              <span className="hidden sm:flex items-center gap-1 text-[11px] font-medium uppercase tracking-[0.22em] text-slate-500">
                <span>{profileData.personal.designation}</span>
                {/* <span className="text-[#2563eb]">•</span>
                <span>AI</span>
                <span className="text-[#2563eb]">•</span>
                <span>AWS</span> */}
              </span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.id); }}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                  isActive(item.id)
                    ? 'text-[#2563eb] bg-blue-50'
                    : 'text-gray-700 hover:text-[#2563eb] hover:bg-gray-50'
                }`}
              >
                {item.name}
              </a>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={(e) => { e.preventDefault(); handleNavClick(item.id); }}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
                    isActive(item.id)
                      ? 'text-[#2563eb] bg-blue-50'
                      : 'text-gray-700 hover:text-[#2563eb] hover:bg-gray-50'
                  }`}
                >
                  {item.name}
                </a>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;